import { render, staticRenderFns } from "./BdssfReportRequirements.vue?vue&type=template&id=61ee0cd0&scoped=true&"
import script from "./BdssfReportRequirements.vue?vue&type=script&lang=js&"
export * from "./BdssfReportRequirements.vue?vue&type=script&lang=js&"
import style0 from "./BdssfReportRequirements.vue?vue&type=style&index=0&id=61ee0cd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ee0cd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
